import { useResponseTypeClasses } from '@heidi/answer-kit';
import { cn } from '@heidi/utils';

/**
 * The Working line's and rows' text: one rung below the thread's body, so it
 * follows the column's density (`text-sm` comfortable, `text-xs` compact).
 */
export const useWorkingRowText = (): string =>
  cn('min-w-0 break-words leading-normal', useResponseTypeClasses().meta);
